"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_scss_1 = __importDefault(require("./index.scss"));
exports.default = {
    table_max_height_mobile: index_scss_1.default.table_max_height_mobile,
    table_pin_icon_size: index_scss_1.default.table_pin_icon_size,
    table_pin_icon_right: index_scss_1.default.table_pin_icon_right,
    table_pin_icon_top: index_scss_1.default.table_pin_icon_top,
    table_top_toolbar_padding: index_scss_1.default.table_top_toolbar_padding,
    table_search_width: index_scss_1.default.table_search_width,
    table_search_margin: index_scss_1.default.table_search_margin,
    table_filter_open_btn_width: index_scss_1.default.table_filter_open_btn_width,
    table_filter_open_btn_margin: index_scss_1.default.table_filter_open_btn_margin,
    table_filter_reset_btn_margin: index_scss_1.default.table_filter_reset_btn_margin,
    table_chip_margin: index_scss_1.default.table_chip_margin,
    table_filter_range_width: index_scss_1.default.table_filter_range_width,
    table_filter_text_min_width: index_scss_1.default.table_filter_text_min_width,
    table_filter_range_input_width: index_scss_1.default.table_filter_range_input_width,
    table_filter_range_input_width_mobile: index_scss_1.default.table_filter_range_input_width_mobile,
    table_filter_dot_size: index_scss_1.default.table_filter_dot_size,
    table_filter_dot_position_top: index_scss_1.default.table_filter_dot_position_top,
    table_filter_dot_position_right: index_scss_1.default.table_filter_dot_position_right,
    table_filter_btns_container_max_width: index_scss_1.default.table_filter_btns_container_max_width,
    table_filter_btns_container_padding: index_scss_1.default.table_filter_btns_container_padding,
    table_filter_reset_btn_container_padding_bottom: index_scss_1.default.table_filter_reset_btn_container_padding_bottom,
    table_pagination_select_width: index_scss_1.default.table_pagination_select_width,
    table_pagination_text_margin: index_scss_1.default.table_pagination_text_margin,
    table_pagination_wrapper_margin: index_scss_1.default.table_pagination_wrapper_margin,
};
